const ArrowIcon = ({ color = 'hsl(36 4% 24%)' }) => {
  return (
    <svg height="20" viewBox="0 0 20 20" width="20" xmlns="SVG namespace">
      <path
        d="m5.11740785 14.180035-2.11740785-2.1252256 7.0808568-7.0548094 7.0365511 7.0106666-2.1174079 2.1252256-4.9191432-4.90104774z"
        fill={color}
        fillRule="evenodd"
      />
    </svg>
  );
};

export default ArrowIcon;
